import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import Typography from '@mui/material/Typography';
import { Select, MenuItem } from "@mui/material";
import TextField from '@mui/material/TextField';
import borders from "assets/mavric-theme/base/borders";
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import ProbeStatus_table from './ProbeStatus_table';
import Divider from '@mui/material/Divider';
import { getProbeListByCustomerId, getCustomers } from 'apis/CustomersApis';
import SearchProbe from './SearchProbe';
const { borderRadius } = borders;
const { primary, secondary, text } = colors;
const { size } = typography;
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`customer-tabpanel-${index}`}
            aria-labelledby={`customer-tab-${index}`}
            {...other}
        >
            <Box m={0} p={0}>{children}</Box>
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `customer-tab-${index}`,
        'aria-controls': `customer-tabpanel-${index}`,
    };
}

const ProbeTable = () => {
    const Token = useSelector(state => state.accessToken);
    const [custDataList, setCustDataList] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState({ customer_id: 0, org_name: "" });
    const [probeData, setProbeData] = useState({});
    const [probeStatusList, setProbeStatusList] = useState([]);
    const probeStatusListRef = useRef([]);
    const [tabValue, setTabValue] = useState(0);

    const columns = [
        { accessorKey: 'total_probes', header: 'Total Probes', size: 100 },
        { accessorKey: 'active_probes', header: 'No. of Active Probes', size: 100 },
        { accessorKey: 'inactive_probes', header: 'No. of Inactive Probes', size: 100 },
    ];

    useEffect(() => {
        getCustomerData();
    }, []);

    useEffect(() => {
        if (custDataList.length > 0) {
            const defaultCustomer = custDataList.find(customer => customer.customer_id === custDataList[0].customer_id) || custDataList[0];
            setSelectedCustomer(defaultCustomer);
            getProbesByCustomerId(defaultCustomer.customer_id, defaultCustomer.org_name);
        }
    }, [custDataList]);

    useEffect(() => {
        let activeProbes = [];
        let inactiveProbes = [];
        if (probeData) {
            if (probeData.active_probes_list &&
                Array.isArray(probeData.active_probes_list) &&
                probeData.active_probes_list.length > 0
            ) activeProbes = probeData.active_probes_list.map(probe => ({ ...probe, probe_status: "ACTIVE" }));
            if (probeData.inactive_probes_list &&
                Array.isArray(probeData.inactive_probes_list) &&
                probeData.inactive_probes_list.length > 0
            ) inactiveProbes = probeData.inactive_probes_list.map(probe => ({ ...probe, probe_status: "INACTIVE" }))
        }
        probeStatusListRef.current = activeProbes.concat(inactiveProbes);
        setProbeStatusList([...activeProbes, ...inactiveProbes])
        // console.log("probeStatusListRef.current:",probeStatusListRef.current);


    }, [probeData]);

    const getFilteredColumns = () => {
        return columns;
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const getCustomerData = () => {
        console.log("Token::", Token);
        return new Promise(function (resolve, reject) {
            getCustomers().then((response) => {
                //setProcessing(false);
                setCustDataList(response);
                // setSelectedCustomer(response[0]);
                // getProbesByCustomerId(response[0].customer_id, response[0].org_name)
                resolve(response);
                // console.log("Get all customers:---->", response);

            }).catch((error) => {
                //setProcessing(false);
                setCustDataList([]);
                let errMessage = '';

                if (error.response) {
                    errMessage = error.response.data.message;
                    if (error.response.status === 401 || error.response.status === 403) {
                        // <Redirect from="/" to="/login" />
                        let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
                        dispatch(logout(jsonPostMsg));
                        history.push('/login');
                    }
                } else if (error.request) {
                    errMessage = `${error}`;
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                    errMessage = error.message;
                }
                reject(errMessage);
            });
        });
    };

    const getProbesByCustomerId = (customerId, customer_name) => {
        return new Promise(function (resolve, reject) {
            getProbeListByCustomerId(customerId).then((response) => {
                let probeData = response;
                // console.log("probeData:---->", probeData);

                probeData.customer_name = customer_name;
                //setProcessing(false);
                setProbeData(probeData);
                resolve(probeData);
            }).catch((error) => {
                //setProcessing(false);
                setProbeData([]);
                let errMessage = '';

                if (error.response) {
                    errMessage = error.response.data.message;
                    if (error.response.status === 401 || error.response.status === 403) {
                        // <Redirect from="/" to="/login" />
                        let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
                        dispatch(logout(jsonPostMsg));
                        history.push('/login');
                    }
                } else if (error.request) {
                    errMessage = `${error}`;
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                    errMessage = error.message;
                }
                reject(errMessage);
            });
        });
    };

    const handleCustomerChange = async (e) => {
        const selectedOrgName = e.target.value;
        // console.log("Selected Customer:", selectedOrgName);
        // setSelectedCustomer(e.target.value);
        const selectedCustomer = custDataList.find(customer => customer.org_name === selectedOrgName);
        if (selectedCustomer) {
            setSelectedCustomer(selectedCustomer);
            await getProbesByCustomerId(selectedCustomer.customer_id, selectedCustomer.org_name);
        } else {
            console.log("Invalid customerId : ", selectedCustomer.customer_id);
        }
    };

    return (
        <>
            <Card
                sx={{
                    borderRadius: '10px',
                    overflow: 'hidden'
                }}>
                <Box sx={{ marginBottom: 2 }}>

                    <Box sx={{ borderColor: 'primary.focus', padding: 0 }}>
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            variant="scrollable"
                            scrollButtons="auto"
                            indicatorColor="secondary"
                            textColor="secondary"
                            allowScrollButtonsMobile={true}
                            aria-label="sso tabs"
                        >
                            <Tab label="View Probe" {...a11yProps(0)} />
                            <Tab label="Search Probe" {...a11yProps(1)} />
                        </Tabs>
                        <Divider sx={{ borderColor: primary.divider, mb: 2 }} />
                    </Box>

                    <TabPanel value={tabValue} index={0}>
                        <Box sx={{ width: "50%", marginLeft: 2, marginBottom: 2, display: "flex", alignItems: "center", gap: 2 }}>
                            <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 600, marginBottom: '8px', whiteSpace: "nowrap" }}>
                                Search Customer Name :
                            </Typography>
                            <Select
                                id="customerId"
                                name="customerId"
                                value={selectedCustomer != null ? selectedCustomer.org_name : ""}
                                onChange={handleCustomerChange}
                                displayEmpty
                                fullWidth
                                sx={{
                                    '.MuiSelect-select': {
                                        paddingTop: '8px !important',
                                        paddingBottom: '8px !important',
                                        minHeight: '35px !important',
                                        display: 'flex',
                                        alignItems: 'center',
                                        fontSize: '1em !important'
                                    }
                                }}
                            >
                                {custDataList && custDataList.length > 0 &&
                                    custDataList.map((customer) => (
                                        <MenuItem key={customer.customer_id} value={customer.org_name}>
                                            {customer.org_name}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </Box>
                        <Box
                            sx={{
                                width: "100%",
                                // maxWidth: "md",
                                backgroundColor: primary.main,
                                padding: 2,
                                borderRadius: 2,
                                // boxShadow: 2, 
                            }}
                        >
                            <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }}>
                                View Probes
                            </Typography>

                            <Grid container>
                                <Typography
                                    variant="body2"
                                    fontSize={size.sm}
                                    justifyContent="center"
                                    color={text.main}
                                    sx={{ fontWeight: 400, mb: 1 }}
                                >
                                    {/* Customer Name:&nbsp;{probeData?.customer_name ?? ""} */}
                                    Customer Name:&nbsp;{probeData && probeData.customer_name ? probeData.customer_name : ""}
                                </Typography>
                            </Grid>

                            <Grid container spacing={2}>
                                {getFilteredColumns().map((column) => (
                                    <Grid item xs={12} sm={4} md={4} lg={4} key={column.accessorKey}>
                                        <Typography
                                            variant="body2"
                                            fontSize={size.sm}
                                            justifyContent="center"
                                            color={text.main}
                                            sx={{ fontWeight: 400, mb: "8px" }}
                                        >
                                            {column.header}
                                        </Typography>
                                        <TextField
                                            id={column.accessorKey}
                                            name={column.accessorKey}
                                            placeholder={column.header}
                                            value={probeData[column.accessorKey] ? probeData[column.accessorKey] : ""}
                                            fullWidth
                                            InputProps={{
                                                readOnly: true,
                                                sx: {
                                                    color: text.main,
                                                    borderColor: primary.focus,
                                                    backgroundColor: "transparent",
                                                    borderRadius: borderRadius.md,
                                                },
                                            }}
                                            InputLabelProps={{ sx: { color: text.main } }}
                                        />
                                    </Grid>
                                ))}
                            </Grid>

                            <Divider sx={{ borderColor: primary.divider, mt: 2, mb: 2 }} />

                            <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 1 }}>
                                Probes Details
                            </Typography>

                            <Box sx={{ width: "100%" }}>
                                {probeStatusList.length > 0 ? (
                                    <ProbeStatus_table
                                        data={probeStatusList}
                                        getProbesByCustomerId={getProbesByCustomerId}
                                        selectedCustomer={selectedCustomer}  
                                    />
                                ) : (
                                    <Box m={4} p={4} sx={{ display: "flex", justifyContent: "center" }}>
                                        <Typography variant="body2" color={text.main} sx={{ fontWeight: 600 }}>
                                            No Probe Details
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </TabPanel>

                    <TabPanel value={tabValue} index={1}>
                        <SearchProbe />
                    </TabPanel>
                </Box>
            </Card>
        </>

    );
};

export default ProbeTable;
